function isOptionEqualToValue(option : any, value: any) {
    return option.value === value.value;
}

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
export const ListBoxProps = {
    style:{
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    }
};